import { Trans } from 'react-i18next';
import i18n from '../../../../../../../lib/i18n';
import { ILoadHistoryEventResponse } from '../../../../interfaces/ILoadHistoryResponse';
import LoadHistoryUtils from '../../utils/load-history-drawer.utils';

function HistoryItemConfirmationTermsAccepted({
    history,
}: Readonly<{
    history: ILoadHistoryEventResponse;
}>) {
    const userEmail = history.metadata?.userEmail ?? '';
    const carrier = history.metadata?.carriers?.[0];
    const carrierName = carrier
        ? LoadHistoryUtils.getCarrierLabel(carrier)
        : i18n.t('CarrierWithoutRegisterOnSulaHub');

    return (
        <div
            key={history.eventDate.toString()}
            className="load-history-event-container load-history-line"
            data-testid="load-history-event-confirmation-terms-accepted"
        >
            <div className="load-history-section-title">
                <h4 className="load-history-event-type">
                    {LoadHistoryUtils.getEventLabel(history)}
                </h4>
            </div>
            <span>{LoadHistoryUtils.getDateTimeLabel(history.eventDate)}</span>
            <span>
                <Trans
                    i18nKey="LoadHistory.TermsAcceptedDescription"
                    values={{ user: userEmail, carrier: carrierName }}
                    shouldUnescape
                />
            </span>
        </div>
    );
}

export default HistoryItemConfirmationTermsAccepted;
